<app-card titleKey="profile.legalEntityInfo">
  @if (genericStore.allLoaded()) {
    <app-legal-person-validated-form
      [formGroupInput]="legalPersonForm"
      [showFillDataButton]="false"
      [taxNumberDisabled]="true"
    />
  }
</app-card>

<div class="d-flex justify-content-end gap-2 px-4 py-4">
  <app-button
    [label]="'general.cancel' | translate"
    variant="default"
    (clicked)="cancelEdit()"
  />
  <app-button
    [iconClass]="'fas fa-save'"
    [label]="'general.save' | translate"
    btnClass="btn btn-primary btn-sm action-btn"
    (clicked)="save()"
    [disabled]="legalPersonForm.invalid"
  />
</div>
